import { PresentationBundleKind } from '@/types/schema';

import { BundleConfigModalState } from '../../PresentationTemplateEditor.context';
import { BeneficiaryBundleConfigModal } from './beneficiaryBundleConfig/BeneficiaryBundleConfigModal';
import { DocumentSummaryBundleConfigModal } from './documentSummaryBundleConfig/DocumentSummaryBundleConfigModal';
import { EntitySummaryBundleConfigModal } from './entitySummaryBundleConfig/EntitySummaryBundleConfigModal';
import { InsightsBundleConfigModal } from './insightsBundleConfig/InsightsBundleConfigModal';
import { WaterfallBundleConfigModal } from './waterfallBundleConfig/WaterfallBundleConfigModal';
import { WaterfallComparisonBundleConfigModal } from './waterfallComparisonBundleConfig/WaterfallComparisonBundleConfigModal';

export interface BundleConfigModalSwitcherProps {
  state: BundleConfigModalState;
  onClose: () => void;
}

export function BundleConfigModalSwitcher({
  state,
  onClose,
}: BundleConfigModalSwitcherProps) {
  switch (state.kind) {
    case PresentationBundleKind.WaterfallOverviewBundle:
      return (
        <WaterfallBundleConfigModal
          bundleIndex={state.bundleIndex}
          onClose={onClose}
        />
      );
    case PresentationBundleKind.BeneficiaryReportBundle:
      return (
        <BeneficiaryBundleConfigModal
          bundleIndex={state.bundleIndex}
          onClose={onClose}
        />
      );
    case PresentationBundleKind.WaterfallComparisonBundle:
      return (
        <WaterfallComparisonBundleConfigModal
          bundleIndex={state.bundleIndex}
          onClose={onClose}
        />
      );
    case PresentationBundleKind.DocumentSummaryBundle:
      return (
        <DocumentSummaryBundleConfigModal
          bundleIndex={state.bundleIndex}
          onClose={onClose}
        />
      );
    case PresentationBundleKind.EstateInsightsBundle:
      return (
        <InsightsBundleConfigModal
          bundleIndex={state.bundleIndex}
          onClose={onClose}
        />
      );
    case PresentationBundleKind.EntitySummaryBundle:
      return (
        <EntitySummaryBundleConfigModal
          bundleIndex={state.bundleIndex}
          onClose={onClose}
        />
      );
    default:
      return null;
  }
}
